<template>
  <div>
    <div @click="launchFile()">
      <slot name="activator"></slot>
    </div>
    <input type="file"
       ref="file"
       :name="filename"
       v-on:change="changeImage($event.target.files)"
       style="display:none">
    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar color="red accent-2" size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card-text class="caption white--text pa-0">
                {{ error.message }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../service/Axios";
  export default {
    name: 'image-input',
    data: () => ({
      dialog: false,
      filename: 'file',
      error: {
        message: ''
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      async changeImage (file) {
        let image = file[0]
        if (file.length > 0) {
          if (image.type != 'image/jpg' && image.type != 'image/jpeg' && image.type != 'image/png') {
            this.dialog = true
            this.error.message = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png'
          } else if (image.size > 5242880) {
            this.dialog = true
            this.error.message = 'Maksimal gambar 5MB'
          } else {
            let formData = new FormData()
            formData.append("key", "59e51e5db668184d8c4a085fb8389c3acfd76a50")
            formData.append("file", image)

            fetch(`${process.env.VUE_APP_API_CDN}`, {
              method: "POST",
              body: formData
            })
            .then(res => res.json())
            .then(response => {
              this.$emit("input", {
                url: response.data[0].original
              })
            })
          }
        }
      }
    }
  }
</script>